import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import CustomizationForm from "@/components/CustomizationForm";
import CaseSection from "./home/CaseSection";
import ContactFloat from "@/components/ContactFloat";

export default function About() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("about.title")}</title>
        <meta name="keywords" content={t("about.keywords")} />
        <meta name="description" content={t("about.description")} />
      </Helmet>
      <ContactFloat />
      <div className="bg-[#0c293d]">
        <div
          className="w-full bg-[url('/images/about.jpg')] bg-center bg-no-repeat bg-cover"
          data-aos="fade-right"
          data-aos-offset="100"
          data-aos-duration="500"
        >
          <div className="w-full h-[280px] sm:h-[340px] md:h-[400px] bg-black/40 relative">
            <div className="max-w-[1200px] mx-auto h-full grid place-content-center px-4">
              <div className="text-center text-[18px] md:text-[20px] font-bold text-white relative">
                <h2
                  className="relative pb-[25px] text-2xl md:text-[30px]"
                  data-aos="fade-right"
                  data-aos-offset="100"
                  data-aos-duration="500"
                >
                  {t("about.banner.title")}
                  <span
                    className="block h-[4px] w-[50px] bg-white mx-auto mt-3"
                    data-aos-delay="300"
                    data-aos="zoom-in"
                  ></span>
                </h2>
                <p
                  className="pt-5 text-base md:text-[18px] leading-relaxed"
                  data-aos="fade-left"
                  data-aos-offset="100"
                  data-aos-duration="500"
                >
                  {t("about.banner.subtitle")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative w-full bg-white pt-10 md:pt-[60px]">
        <div className="max-w-[1200px] mx-auto px-4 md:px-5">
          <h2
            className="font-bold text-[#222] text-[26px] md:text-[34px] text-center pb-[16px] md:pb-[20px] leading-tight"
            data-aos-delay="100"
            data-aos="fade-up"
          >
            {t("about.section.title")}
          </h2>
          <p className="text-center text-[#666] text-[15px] md:text-[18px] leading-relaxed px-2" data-aos="fade-up">
            {t("about.section.subtitle")}
          </p>
          <div className="pt-8 md:pt-[60px] flex flex-col md:flex-row gap-8 md:gap-14 items-start">
            <div
              className="w-full md:w-2/5"
              data-aos="fade-right"
              data-aos-offset="300"
              data-aos-easing="ease-in-sine"
            >
              <img className="w-full" src="/images/about_02.jpg" alt="" />
            </div>
            <div className="flex-1 w-full">
              <h2
                className="pt-2.5"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                <span className="text-2xl md:text-[34px] text-[#0f5f95] font-bold pr-4">
                  {t("about.brand.name_en")}
                </span>
              </h2>
              <h3
                className="text-[18px] text-[#666] pt-5 pb-10"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("about.brand.slogan")}
              </h3>
              <p
                className="text-[16px] text-left text-[#222] leading-[28px] pb-[40px]"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("about.intro.p1")}
              </p>
              <p
                className="text-[16px] text-left text-[#222] leading-[28px] pb-[40px]"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("about.intro.p2")}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/** 合作案例 */}
      <CaseSection />

      <div className="relative w-full bg-[#f2f4f6] pt-10 md:pt-[40px] pb-12 md:pb-[80px]">
        <div className="max-w-[1200px] mx-auto px-4 md:px-5">
          <h2
            className="font-bold text-[#222] text-[26px] md:text-[34px] text-center pb-[10px] leading-tight"
            data-aos-delay="100"
            data-aos="fade-up"
          >
            {t("about.contact.title")}
          </h2>
          <p
            className="text-center text-[#666] text-[15px] md:text-[18px] pt-4 pb-6 leading-relaxed px-2"
            data-aos-delay="100"
            data-aos="fade-up"
          >
            {t("about.contact.subtitle")}
          </p>
          <div
            className="border-t border-[#ddd] py-8 mt-[10px] text-left"
            data-aos="fade-up"
            data-aos-anchor-placement="top-bottom"
            id="intromsg"
            style={{ display: "block" }}
          >
            <p className="leading-6 text-[#666] text-sm px-4 md:px-[130px]">
              {t("scheme.form.intro.p1")}
              {t("scheme.form.intro.p2")}
            </p>
          </div>
          <CustomizationForm />
        </div>
      </div>
    </>
  );
}
